export interface Download {
  doDownload(file: Blob | Promise<Blob>, filename: string): Promise<void>;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Download = Symbol('Download');
